import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class TransactionPaymentForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>

            </form>
        );
    }
}

export default createForm(TransactionPaymentForm);
